import { createChildListPrintComponent } from 'factories/ChildListPrint'

export default createChildListPrintComponent({
  entityName: 'processSetupSheet',
  childName: 'associatedAssets',
})()
